// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__Z2AwF","inner":"styles_inner__2q8qH","text_white":"styles_text_white__1izOG","active":"styles_active__2TXHP","left":"styles_left__3W2KC"};